/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SendRequestToAccountManagerRequestTypeFromJSON, SendRequestToAccountManagerRequestTypeToJSON, } from './SendRequestToAccountManagerRequestType.js';
/**
 * Check if a given object implements the SendRequestToAccountManagerCommandDto interface.
 */
export function instanceOfSendRequestToAccountManagerCommandDto(value) {
    if (!('requestType' in value) || value['requestType'] === undefined)
        return false;
    return true;
}
export function SendRequestToAccountManagerCommandDtoFromJSON(json) {
    return SendRequestToAccountManagerCommandDtoFromJSONTyped(json, false);
}
export function SendRequestToAccountManagerCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'requestType': SendRequestToAccountManagerRequestTypeFromJSON(json['requestType']),
    };
}
export function SendRequestToAccountManagerCommandDtoToJSON(json) {
    return SendRequestToAccountManagerCommandDtoToJSONTyped(json, false);
}
export function SendRequestToAccountManagerCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'requestType': SendRequestToAccountManagerRequestTypeToJSON(value['requestType']),
    };
}
